import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { ExportType } from "../../../../../docuclipper/DocuclipperTypes";

type Props = { selectedExportType: ExportType };
export const Instructions: React.FC<Props> = ({ selectedExportType }) => {
  let links: { text: string; link: string }[] = [];
  switch (selectedExportType) {
    // case "csv":
    //   links.push({
    //     link: "/help-center/convert-bank-statements-to-excel/",
    //     text: "Excel instructions",
    //   });

    //   break;
    case "qbo":
      links.push({
        link: "/docs/import-bank-statement-transactions-into-quickbooks-online/",
        text: "QuickBooks Online instructions",
      });
      links.push({
        link: "/docs/import-bank-statement-transactions-into-quickbooks-desktop-web-connect/",
        text: "QuickBooks Desktop instructions",
      });
      break;
    case "xero-csv":
      links.push({
        link: "/docs/import-bank-statement-transactions-into-xero/",
        text: "Xero instructions",
      });
      break;
    case "xero-sync":
      // No external instructions needed for direct sync
      break;
    case "sage-csv":
    case "sage-cloud-csv":
      links.push({
        link: "/docs/import-bank-statement-transactions-into-sage/",
        text: "Sage instructions",
      });
      break;
    case "iif":
      links.push({
        link: "/docs/import-bank-statement-transactions-into-quickbooks-desktop-iif/",
        text: "IIF instructions",
      });
      break;
    default:
      //   if (selectedExportType?.startsWith("custom-")) {
      // links.push({
      //   link: "/help-center/convert-bank-statements-to-excel/",
      //   text: "Excel instructions",
      // });
      //   }
      break;
  }
  return (
    <>
      {links.map((link, idx) => (
        <div className="text-right" key={idx}>
          <a href={link.link} target="_blank" rel="noopener noreferrer">
            <div className="ml-2 div--help-video">
              <FontAwesomeIcon icon="question-circle" />
              <span className="ml-2" /*variant="link"*/>{link.text}</span>
            </div>
          </a>
        </div>
      ))}
    </>
  );
};
export default Instructions;
